"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Roughly inspired from https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Breadcrumbs/Breadcrumbs.js
const react_1 = __importDefault(require("react"));
const md_1 = require("react-icons/md");
const Button_1 = require("../Button/Button");
const Typography_1 = require("../Typography/Typography");
function insertSeparators(items) {
    return items.reduce((acc, current, index) => {
        if (index < items.length - 1) {
            acc = acc.concat(current, (0, jsx_runtime_1.jsx)("li", Object.assign({ "aria-hidden": true, className: "hidden md:list-item" }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: "h200", className: "ml-5" }, { children: "/" })) }), `separator-${index}`));
        }
        else {
            acc.push(current);
        }
        return acc;
    }, []);
}
function Breadcrumb({ children, className = '', onBackClick }) {
    const allItems = react_1.default.Children.toArray(children)
        .filter((child) => react_1.default.isValidElement(child))
        .map((child, index) => {
        return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: "hidden md:list-item" }, { children: child }), `child-${index}`));
    });
    return ((0, jsx_runtime_1.jsxs)("ol", Object.assign({ className: `flex items-center text-silver-90 ${className}` }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({ variant: "tertiary", className: "!px-3", onClick: onBackClick }, { children: (0, jsx_runtime_1.jsx)(md_1.MdArrowBack, { size: 20 }) })), insertSeparators(allItems)] })));
}
exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map